import { Injectable, inject } from '@angular/core';
import { TwcRefreshLayerPluginService } from '../../../../twc.refresh-layer-plugin.service';
import { VOLCANIC_ASH_CLOUDS_PRODUCT_DATA_VECTOR_TILE } from './volcanic-ash-clouds.twc-product-data';

@Injectable({
  providedIn: 'root'
})
export class VolcanicAshCloudsPluginService {
  private _twcPluginService = inject(TwcRefreshLayerPluginService);

  plugin$ = this._twcPluginService.create(
    VOLCANIC_ASH_CLOUDS_PRODUCT_DATA_VECTOR_TILE,
    {
      twcLayerTypes: ['vector-tile']
    }
  );
}
